import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AnnouncementStatus } from '../../../../core/models/announcement.model';

@Component({
  selector: 'app-status-banner',
  standalone: true,
  imports: [CommonModule, DatePipe],
  template: `
    <div class="status-banner" [ngClass]="status.toLowerCase() || ''">
      <div class="status-info">
        <i class="fas fa-info-circle"></i>
        <div class="text">
          <span class="status-name">Status: {{ statusText }}</span>
          <p class="reason" *ngIf="rejectionReason">Səbəb: {{ rejectionReason }}</p>
          <p class="expiry" *ngIf="expiresAt">Müddət bitir: {{ expiresAt | date:'dd.MM.yyyy HH:mm' }}</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .status-banner {
      padding: 16px 24px;
      border-radius: 12px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      gap: 16px;
    }
    .status-info {
      display: flex;
      gap: 16px;
      align-items: flex-start;
    }
    .status-info i {
      font-size: 20px;
      margin-top: 2px;
    }
    .status-name {
      font-weight: 700;
      font-size: 16px;
    }
    .reason, .expiry {
      margin: 4px 0 0;
      font-size: 14px;
      opacity: 0.9;
    }
    .pending { background: #fff3e0; color: #e65100; border: 1px solid #ffe0b2; }
    .rejected { background: #ffeeb2; color: #7b1fa2; border: 1px solid #fff9c4; } /* Adjusted for rejected look in real apps or as specified */
    .rejected { background: #ffebee; color: #c62828; border: 1px solid #ffcdd2; }
    .deactivated { background: #f5f5f5; color: #616161; border: 1px solid #e0e0e0; }
    .expired { background: #efebe9; color: #4e342e; border: 1px solid #d7ccc8; }
    .paused { background: #f5f5f5; color: #616161; border: 1px solid #e0e0e0; }
  `]
})
export class StatusBannerComponent {
  @Input() status!: AnnouncementStatus;
  @Input() rejectionReason?: string;
  @Input() expiresAt?: Date;

  get statusText(): string {
    switch (this.status) {
      case AnnouncementStatus.Pending: return 'Gözləmədə';
      case AnnouncementStatus.Rejected: return 'İmtina edilib';
      case AnnouncementStatus.Deactivated: return 'Deaktiv edilib';
      case AnnouncementStatus.Expired: return 'Vaxtı bitib';
      case AnnouncementStatus.Paused: return 'Dayandırılıb';
      default: return this.status;
    }
  }
}
